import { render, staticRenderFns } from "./ConfirmarInternacaoModal.vue?vue&type=template&id=20952dd5&scoped=true"
import script from "./ConfirmarInternacaoModal.vue?vue&type=script&lang=js"
export * from "./ConfirmarInternacaoModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmarInternacaoModal.vue?vue&type=style&index=0&id=20952dd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20952dd5",
  null
  
)

export default component.exports